export const TEXT_SIZES = {
  lg: {
    fontSize: "20px",
    lineHeight: "30px",
  },
  md: {
    fontSize: "16px",
    lineHeight: "24px",
  },
  sm: {
    fontSize: "14px",
    lineHeight: "20px",
  },
  xs: {
    fontSize: "12px",
    lineHeight: "20px",
  },
};
